// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { createAuthProvider } from "react-token-auth";

// import store from "../store";
import { axios } from "../commons";

const _ = {
  state: {
    isInitializing: true,
    isAuthenticated: false,
    member: {},
  },
  reducers: {
    setInitializing(state, payload) {
      return { ...state, isInitializing: payload };
    },
    setAuthenticated(state, payload) {
      return { ...state, isAuthenticated: payload };
    },
    setMember(state, payload) {
      return { ...state, member: payload };
    },
  },
  effects: (dispatch) => ({
    async authenticate() {
      let isSuccess = false;

      const session = await authProvider.getSession();
      // console.debug({ session });

      if (!session) {
        this.setInitializing(false);
        return isSuccess;
      }

      try {
        const { data } = await axios(`/api/auth/whoami`);
        // console.debug({ data, status });

        if (!data.isAdmin) {
          throw new Error("Not admin");
        }

        this.setMember(data);
        this.setAuthenticated(true);

        isSuccess = true;
      } catch (err) {
        console.error(err);
        // authProvider.logout();
      }

      this.setInitializing(false);

      return isSuccess;
    },
    async signout() {
      // await signOut(auth);
      this.setAuthenticated(null);
      this.setMember({});
      // signOut(getAuth());
      authProvider.logout();
    },
  }),
};
export default _;

// onAuthStateChanged(
//   getAuth(),
//   (user) => {
//     const au = store.dispatch.auth;
//     if (user) {
//       // console.debug({ user });

//       au.setMember({
//         uid: user.uid,
//         disabled: user.disabled,
//         displayName: user.displayName,
//         photoURL: user.photoURL,
//         email: user.email,
//         emailVerified: user.emailVerified,
//         metadata: user.metadata,
//         providerData: user.providerData,
//       });
//       au.setAuthenticated(true);

//       // auth()
//       //   .currentUser.getIdTokenResult()
//       //   .then((idTokenResult) => {
//       //     console.log({ idTokenResult });

//       //     // Confirm the user is an Admin.
//       //     if (!!idTokenResult.claims.admin) {
//       //       // Show admin UI.
//       //       // showAdminUI();
//       //     } else {
//       //       // Show regular user UI.
//       //       // showRegularUI();
//       //     }
//       //   })
//       //   .catch((error) => {
//       //     console.log(error);
//       //   });
//     } else {
//       au.signout();
//     }

//     au.setInitializing(false);
//   },
//   () => {
//     // store.dispatch.auth.setInitializing(false);
//   }
// );

export const authProvider = createAuthProvider({
  getAccessToken: (session) => session.accessToken,
  // onUpdateToken: (session) =>
  //   axios
  //     .post("/api/auth/token/refresh", {
  //       refreshToken: session.refreshToken,
  //     })
  //     .then((r) => r.data),
});
